/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useState } from 'react';
import styled from 'styled-components';

const Button = styled.button`
  padding: 5px 10px;
  background-color: #aca7a4;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #9a9694;
  }
`;

interface KakaoAddressSearchProps {
  onComplete: (address: string, zipCode: string) => void; // Callback function with address and zip code
}

const KakaoAddressSearch: React.FC<KakaoAddressSearchProps> = ({
  onComplete,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openAddressSearch = () => {
    const script = document.createElement('script');
    script.src =
      'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => {
      const element = document.createElement('div');
      element.style.position = 'fixed';
      element.style.top = '50%';
      element.style.left = '50%';
      element.style.transform = 'translate(-50%, -50%)';
      element.style.zIndex = '1000';
      document.body.appendChild(element);

      const postCode = new (window as any).daum.Postcode({
        oncomplete: (data: any) => {
          // 전달할 주소와 우편번호
          onComplete(data.address, data.zonecode);
          if (element.parentNode) {
            document.body.removeChild(element);
          }
          setIsOpen(false);
        },
        onclose: () => {
          if (element.parentNode) {
            document.body.removeChild(element);
          }
          setIsOpen(false);
        },
      });
      postCode.open({
        popupName: 'addressSearch',
        container: element,
      });
    };

    if (!isOpen) {
      setIsOpen(true);
      document.body.appendChild(script);
    }
  };

  return (
    <Button type="button" onClick={openAddressSearch}>
      우편번호검색
    </Button>
  );
};

export default KakaoAddressSearch;
